import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClientProvider } from './utils/ClientContext';
import appInsights from './utils/AppInsights';
import { initGTM } from './utils/gtm';

if (typeof window !== 'undefined' && process.env.REACT_APP_GTM_ID) {
  initGTM(process.env.REACT_APP_GTM_ID);
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
appInsights.trackPageView();
root.render(
  <React.StrictMode>
    <ClientProvider>
    <App />
    </ClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
